var _path, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 32,
    viewBox: "0 0 138 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2642 8.45455V23H44.2472V13.4972H44.3679L48.1321 22.929H50.1634L53.9276 13.5327H54.0483V23H57.0312V8.45455H53.2386L49.233 18.2273H49.0625L45.0568 8.45455H41.2642ZM62.619 23.206C64.2312 23.206 65.2752 22.5028 65.8079 21.4872H65.8931V23H68.7624V15.642C68.7624 13.0426 66.5607 11.9489 64.1317 11.9489C61.5181 11.9489 59.7994 13.1989 59.3803 15.1875L62.1786 15.4148C62.3846 14.6903 63.0309 14.1577 64.1175 14.1577C65.1474 14.1577 65.7369 14.6761 65.7369 15.571V15.6136C65.7369 16.3168 64.9911 16.4091 63.0948 16.5938C60.9357 16.7926 58.9968 17.517 58.9968 19.9531C58.9968 22.1122 60.538 23.206 62.619 23.206ZM63.4854 21.1179C62.555 21.1179 61.8874 20.6847 61.8874 19.8537C61.8874 19.0014 62.5906 18.5824 63.6559 18.4332C64.3164 18.3409 65.396 18.1847 65.7582 17.9432V19.1009C65.7582 20.2443 64.8136 21.1179 63.4854 21.1179ZM76.9123 12.0909H74.8597V9.47727H71.8342V12.0909H70.3427V14.3636H71.8342V20.0455C71.82 22.1832 73.2759 23.2415 75.4705 23.1491C76.2518 23.1207 76.8058 22.9645 77.1112 22.8651L76.6353 20.6136C76.4862 20.642 76.1665 20.7131 75.8825 20.7131C75.2788 20.7131 74.8597 20.4858 74.8597 19.6477V14.3636H76.9123V12.0909ZM83.7376 23.2131C86.4364 23.2131 88.2546 21.8991 88.6808 19.875L85.8825 19.6903C85.5771 20.5213 84.7958 20.9545 83.7873 20.9545C82.2745 20.9545 81.3157 19.9531 81.3157 18.3267V18.3196H88.7447V17.4886C88.7447 13.7812 86.5004 11.9489 83.6168 11.9489C80.4066 11.9489 78.3256 14.2287 78.3256 17.5952C78.3256 21.054 80.3782 23.2131 83.7376 23.2131ZM81.3157 16.4446C81.3796 15.2017 82.3242 14.2074 83.6665 14.2074C84.9805 14.2074 85.8896 15.1449 85.8967 16.4446H81.3157ZM90.7191 23H93.7447V16.8281C93.7447 15.4858 94.7248 14.5625 96.06 14.5625C96.479 14.5625 97.0543 14.6335 97.3384 14.7259V12.0412C97.0685 11.9773 96.6921 11.9347 96.3867 11.9347C95.1651 11.9347 94.1637 12.6449 93.766 13.9943H93.6523V12.0909H90.7191V23ZM98.9027 23H101.928V12.0909H98.9027V23ZM100.423 10.6847C101.325 10.6847 102.063 9.99574 102.063 9.15057C102.063 8.3125 101.325 7.62358 100.423 7.62358C99.5277 7.62358 98.7891 8.3125 98.7891 9.15057C98.7891 9.99574 99.5277 10.6847 100.423 10.6847ZM107.463 23.206C109.075 23.206 110.119 22.5028 110.652 21.4872H110.737V23H113.606V15.642C113.606 13.0426 111.404 11.9489 108.975 11.9489C106.362 11.9489 104.643 13.1989 104.224 15.1875L107.022 15.4148C107.228 14.6903 107.875 14.1577 108.961 14.1577C109.991 14.1577 110.581 14.6761 110.581 15.571V15.6136C110.581 16.3168 109.835 16.4091 107.939 16.5938C105.779 16.7926 103.841 17.517 103.841 19.9531C103.841 22.1122 105.382 23.206 107.463 23.206ZM108.329 21.1179C107.399 21.1179 106.731 20.6847 106.731 19.8537C106.731 19.0014 107.434 18.5824 108.5 18.4332C109.16 18.3409 110.24 18.1847 110.602 17.9432V19.1009C110.602 20.2443 109.657 21.1179 108.329 21.1179ZM118.979 8.45455H115.953V23H118.979V8.45455ZM124.428 8.45455H121.403V23H124.428V8.45455ZM128.72 27.0909C130.971 27.0909 132.164 25.9403 132.782 24.179L137.022 12.1051L133.819 12.0909L131.539 20.1023H131.426L129.167 12.0909H125.985L129.899 23.3125L129.721 23.7741C129.324 24.7969 128.564 24.8466 127.498 24.5199L126.816 26.7784C127.25 26.9631 127.953 27.0909 128.72 27.0909Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27814 22.6535H8.23697C7.86378 22.6536 7.49654 22.5601 7.16875 22.3817C6.84096 22.2033 6.56308 21.9457 6.36046 21.6323C6.15784 21.3189 6.03694 20.9597 6.0088 20.5876C5.98066 20.2155 6.04618 19.8422 6.19936 19.5019L10.3338 10.3172C10.5032 9.94106 10.7734 9.61911 11.1146 9.3871C11.4557 9.15508 11.8544 9.02204 12.2665 9.00272C12.6787 8.98341 13.0881 9.07858 13.4494 9.27767C13.8108 9.47677 14.1099 9.77202 14.3138 10.1307C14.4869 10.4351 14.5859 10.7759 14.6029 11.1256C14.6198 11.4754 14.5543 11.8242 14.4116 12.1439L10.3196 21.3286C10.1435 21.7229 9.85708 22.0579 9.49482 22.293C9.13257 22.5281 8.71 22.6533 8.27814 22.6535ZM18.2642 21.3286L22.3575 12.1439C22.5002 11.8242 22.5658 11.4754 22.5488 11.1256C22.5318 10.7759 22.4328 10.4351 22.2597 10.1307V10.1307C22.0559 9.77202 21.7567 9.47677 21.3953 9.27767C21.034 9.07858 20.6246 8.98341 20.2124 9.00272C19.8003 9.02204 19.4016 9.15508 19.0605 9.3871C18.7193 9.61911 18.4491 9.94106 18.2797 10.3172L14.1453 19.5019C13.9921 19.8422 13.9266 20.2155 13.9547 20.5876C13.9829 20.9597 14.1038 21.3189 14.3064 21.6323C14.509 21.9457 14.7869 22.2033 15.1147 22.3817C15.4424 22.5601 15.8097 22.6536 16.1829 22.6535H16.224C16.6558 22.6534 17.0782 22.5282 17.4403 22.293C17.8023 22.0579 18.0885 21.7229 18.2642 21.3286ZM26.2114 21.3286L26.8057 19.992C26.9471 19.6741 27.0121 19.3275 26.9956 18.9799C26.979 18.6324 26.8814 18.2935 26.7105 17.9904L26.6912 17.9557C26.4891 17.5945 26.1906 17.2966 25.829 17.0951C25.4674 16.8936 25.057 16.7965 24.6435 16.8147C24.2299 16.8328 23.8296 16.9655 23.487 17.1978C23.1445 17.4302 22.8732 17.7531 22.7035 18.1307L22.086 19.5019C21.9329 19.8422 21.8673 20.2155 21.8955 20.5876C21.9236 20.9597 22.0445 21.3189 22.2471 21.6323C22.4498 21.9457 22.7276 22.2033 23.0554 22.3817C23.3832 22.5601 23.7505 22.6536 24.1236 22.6535H24.1648C24.5976 22.6543 25.0212 22.5295 25.3845 22.2944C25.7477 22.0592 26.035 21.7237 26.2114 21.3286Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49,
    d: "M11.7013 18.2258L14.4117 12.1439C14.5545 11.8242 14.62 11.4754 14.603 11.1256C14.586 10.7759 14.487 10.4351 14.3139 10.1307V10.1307C14.1101 9.77202 13.8109 9.47677 13.4496 9.27767C13.0882 9.07858 12.6788 8.98341 12.2667 9.00272C11.8546 9.02204 11.4559 9.15508 11.1147 9.3871C10.7736 9.61911 10.5033 9.94106 10.3339 10.3172L8.9292 13.438C10.6092 14.8556 11.3643 16.7298 11.7013 18.2258Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.55,
    d: "M16.6562 13.9229L14.1452 19.5019C13.992 19.8422 13.9265 20.2155 13.9546 20.5876C13.9827 20.9597 14.1036 21.3189 14.3063 21.6323C14.5089 21.9457 14.7868 22.2033 15.1145 22.3817C15.4423 22.5601 15.8096 22.6536 16.1828 22.6535H16.2239C16.6558 22.6533 17.0784 22.5281 17.4406 22.293C17.8029 22.0579 18.0893 21.7229 18.2654 21.3286L19.2225 19.1803C17.3894 17.5531 16.8144 15.4319 16.6562 13.9229Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.55,
    d: "M26.695 17.9557C26.5419 17.6823 26.333 17.4441 26.082 17.2566C25.8309 17.0691 25.5433 16.9364 25.2376 16.8671C24.932 16.7979 24.6153 16.7936 24.3079 16.8546C24.0005 16.9156 23.7094 17.0405 23.4534 17.2212C24.7513 18.6812 25.3019 20.7073 25.5334 22.1879C25.8275 21.9624 26.0605 21.667 26.2113 21.3286L26.8057 19.992C26.947 19.6741 27.012 19.3275 26.9955 18.9799C26.9789 18.6324 26.8813 18.2935 26.7105 17.9904L26.695 17.9557Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.49,
    d: "M14.3137 10.1307C14.0739 9.70435 13.7001 9.36901 13.2503 9.17667C12.8005 8.98433 12.2998 8.94574 11.8259 9.06689C11.7744 11.4878 12.6582 13.5023 13.3013 14.6356L14.4115 12.1439C14.5542 11.8242 14.6198 11.4754 14.6028 11.1256C14.5858 10.7759 14.4868 10.4351 14.3137 10.1307V10.1307Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.99997,
    y1: 15.8268,
    x2: 27,
    y2: 15.8268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0043A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1140AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3C38AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#822CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.9292,
    y1: 13.6129,
    x2: 14.606,
    y2: 13.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.9458,
    y1: 18.2876,
    x2: 19.2225,
    y2: 18.2876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 504.388,
    y1: 455.658,
    x2: 602.114,
    y2: 455.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 167.849,
    y1: 255.996,
    x2: 167.849,
    y2: 8.99765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 13.6535,
    fill: "white",
    transform: "translate(6 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.73cf184b11041549695909ac089e4bbf.svg";
export { ForwardRef as ReactComponent };